/*
    Description: public facing js entry point for all our sites interactions
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

// use strict
'use strict';

//imports - global
import "../css/main.scss";
import Translate from "./inc/translate";
import Menu from "./inc/menu";
import Search from "./inc/search";
import Subscribe from "./inc/subscribe";
import Contact from "./inc/contact";
import Staff from "./inc/staff";
import Cards from "./inc/cards";
import LoadMore from "./inc/loadmore";
import Terms from "./inc/terms";
import Videos from "./inc/videos";

// --------------------------------------------------- //
//DOM Ready ------------------------------------------ //
// --------------------------------------------------- //
document.onreadystatechange = () => { 
    
    // DOM ready state complete 
    if(document.readyState == 'complete'){
        
        // add terms interaction
        const translate = new Translate();

        // add main menu overlay script
        const menu = new Menu();

        // add search overlay script
        const search = new Search();

        // add subscribe overlay script
        const subscribe = new Subscribe();

        // add contact overlay script
        const contact = new Contact();

        // add staff overlay script
        const staff = new Staff();

        // add maps card gui interactions
        const mapCards = new Cards({
            cardGUIClass:"maprow__main__right__gui",
            cardWrapperClass:"maprow__main__right__wrapper",
            rightBttnClass:"--js-map-right",
            leftBttnClass:"--js-map-left",
            dragClass:"--js-map-dragging",
            hideClass:"--js-hide",
            cardClass:"--js-card"
        });

        // add events card gui interactions
        const eventsCards = new Cards({
            cardGUIClass:"eventsrow__main__right__gui",
            cardWrapperClass:"eventsrow__main__right__wrapper",
            rightBttnClass:"--js-events-right",
            leftBttnClass:"--js-events-left",
            dragClass:"--js-events-dragging",
            hideClass:"--js-hide",
            cardClass:"--js-card"
        });

        // add resources card gui interactions
        const resourcesCards = new Cards({
            cardGUIClass:"resourcesrow__main__right__gui",
            cardWrapperClass:"resourcesrow__main__right__wrapper",
            rightBttnClass:"--js-resources-right",
            leftBttnClass:"--js-resources-left",
            dragClass:"--js-resources-dragging",
            hideClass:"--js-hide",
            cardClass:"--js-card"
        });
        
        // load more cards
        const loadMore = new LoadMore({
            cardWrapperClass:"--js-card-wrapper",
            loadButtonClass:"--js-load-more",
            nonceClass:"-js-card-nonce",
            loadClass:"--loading",
            hideClass:"--js-hide",
            cardClass:"--js-card"
        });
        
        // add terms interaction
        const terms = new Terms();

        // add videos
        const videos = new Videos({
            loadMoreLinkClass:"--js-load-more-videos",
            nonceClass:"--js-video-nonce",
            ulClass:"videolibrary__ul",
            videoErrorClass:"--js-video-error",
            errorClass:"--error",
            loadClass:"--loading",
        });

    }

};